<app-modal-header [modalTitle]="modalTitle" [showCloseBtn]="false"></app-modal-header>
<!-- Modal Content -->
<div class="modal-content h-100 w-100" [attr.loading]="loading" [attr.size]="'large'" [attr.flexDirection]="'row'">
    <section *ngIf="!loading" class="primary-section-container h-100 w-100">
        <ag-grid-angular
            id="reco-buy-qty-submit"
            class="ag-theme-alpine ag-grid-container"
            [gridOptions]="gridOptions"
            [columnDefs]="columnDefs"
            [rowData]="rowData"
            [cellSelection]="true"
            [attr.tool-panel]="true"
        ></ag-grid-angular>
        <span class="submitted-rows-msg">{{ selectedRows.length }} row(s) will be submitted for optimization.</span>
    </section>
    <!-- Loading Component -->
    <app-loader *ngIf="loading"></app-loader>
</div>
<!-- Modal Footer -->
<app-modal-footer
    [disabled]="deliveryFormErrors || !selectedRows.length"
    (update)="onSubmit()"
    (closeModal)="close()"
    [closeBtnText]="'Close'"
></app-modal-footer>
